export default __webpack_public_path__ + "static/media/mail.95d07d9b.svg";